import { _ as c } from "./extends-093996c9.js";
import e from "react";

var t = function t(_t) {
  var r = _t.dark,
      l = void 0 === r ? "#1D1D1B" : r,
      v = _t.light,
      a = void 0 === v ? "#ffffff" : v,
      o = _t.schema,
      h = {
    isotypebackground: l,
    isotypeletter: l,
    letters: l
  };
  return "light" === (void 0 === o ? "common" : o) && (h.isotypebackground = a, h.isotypeletter = a, h.letters = a), e.createElement("svg", c({
    x: "0px",
    y: "0px",
    viewBox: "0 0 172.3 57.6"
  }, _t), e.createElement("g", {
    fill: h.letters
  }, e.createElement("path", {
    d: "M14,18.2c2-2.8,4.8-4.6,8.5-4.6c7.8,0,12.4,6.8,12.4,16.1c0,10-7.1,16.1-15,16.1 c-1.7,0-4-0.4-5.9-1.5v9.6c0,1.8,0.4,2,3.7,2.4v1.3H0v-1.3c3.3-0.3,3.7-0.6,3.7-2.4v-34c0-2.3-0.4-2.5-3.7-2.8v-1.3l13.1-2.1H14 l-0.3,4.6H14z M14,19.7v16.6c0,6.6,2.9,7.6,4.6,7.6c4,0,5.4-5.3,5.4-13.6c0-8.5-2.8-12-6.3-12C16.4,18.2,15.2,18.8,14,19.7z"
  }), e.createElement("path", {
    d: "M64.6,40.4c0,0.8,0.5,1.4,1.4,1.4c0.7,0,1.6-0.4,2.4-0.9l0.2,1.3c-2.5,2-5.7,3.7-9.2,3.7 c-3.5,0-5.1-1.9-5.1-4.2v-0.7h-0.1c-2.1,3.1-5.2,5-8.9,5c-4.7,0-7.4-3.2-7.4-7.3c0-3.8,3-9,16.4-9.8v-5.9c0-3.3-1.6-6.3-5.6-6.3 C46.1,16.4,44,18,44,20c0,2.1,2.6,2.6,2.6,4.4c0,1.4-1.6,2.6-3.9,2.6c-2,0-4-0.9-4-3.2c0-3.5,5-10.2,14-10.2 c7.6,0,11.9,4.2,11.8,9.5V40.4z M54.2,30.3c-3.7,0.5-5.9,2.2-5.9,5.8c0,2.7,1.2,4,3,4c1.2,0,2-0.5,2.9-1.1V30.3z"
  }), e.createElement("path", {
    d: "M93,19.9c0-2.3-0.4-2.5-4.9-2.8v-1.3l14.1-2.1h1.1v26.6c0,2.3,0.4,2.5,3.7,2.8v1.3l-12.6,1.5 h-0.9l-0.2-6.5H93c-2.8,3.7-6.6,6.5-11.1,6.5c-4.6,0-8.5-2.5-8.5-9.3V19.9c0-2.3-0.4-2.5-3.7-2.8v-1.3l12.9-2.1h1.1v22.7 c0,2.5,1.1,4,3.3,4c2.8,0,4.6-1.5,5.9-2.5V19.9z"
  }), e.createElement("path", {
    d: "M122.6,41.5c0,1.8,0.4,2,3.7,2.4v1.3h-17.6v-1.3c3.3-0.3,3.7-0.6,3.7-2.4V5.6 c0-2.3-0.4-2.5-3.7-2.8V1.5L121.7,0h0.9V41.5z"
  }), e.createElement("path", {
    d: "M155,40.4c0,0.8,0.5,1.4,1.4,1.4c0.7,0,1.6-0.4,2.4-0.9l0.2,1.3c-2.5,2-5.7,3.7-9.2,3.7 s-5.1-1.9-5.1-4.2v-0.7h-0.1c-2.1,3.1-5.2,5-8.9,5c-4.7,0-7.4-3.2-7.4-7.3c0-3.8,3-9,16.4-9.8v-5.9c0-3.3-1.6-6.3-5.6-6.3 c-2.5,0-4.6,1.6-4.6,3.6c0,2.1,2.6,2.6,2.6,4.4c0,1.4-1.6,2.6-3.9,2.6c-2,0-4-0.9-4-3.2c0-3.5,5-10.2,14-10.2 c7.6,0,11.9,4.2,11.8,9.5V40.4z M144.7,30.3c-3.7,0.5-5.9,2.2-5.9,5.8c0,2.7,1.2,4,3,4c1.2,0,2-0.5,2.9-1.1V30.3z"
  }), e.createElement("path", {
    d: "M167.6,36.2c2.5,0,4.6,2.1,4.6,4.7c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6 C163,38.3,165.1,36.2,167.6,36.2z"
  })));
};

export { t as Paula };